<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("term.list_page_title") }}</h3>
    <md-button
      v-if="$can(Term.actions.add, Term.subject)"
      class="md-success btn-search ml-6"
      @click="showModal"
    >
      {{ this.$t("common.add_new") }}
    </md-button>
    <add-term
      ref="modalRef"
      :name="name"
      :title="$t('term.add_new_term')"
    ></add-term>
  </div>
</template>

<script>
import AddTerm from "../AddTerm.vue";
import { Term } from "@/constants/Permissions";

export default {
  components: { AddTerm },
  name: "ListPageHeader",
  data() {
    return {
      name: "addTerm",
      Term
    };
  },
  methods: {
    showModal() {
      this.$modal.show(this.name);
    }
  }
};
</script>
